var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 87,
    fill: "#2A7F77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5996 101.177H93.0116C93.8396 101.177 94.5116 100.506 94.5116 99.6772C94.5116 98.8482 93.8396 98.1772 93.0116 98.1772H73.5996C72.7716 98.1772 72.0996 98.8482 72.0996 99.6772C72.0996 100.506 72.7716 101.177 73.5996 101.177Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8779 105.482H66.2959C65.4679 105.482 64.7959 106.153 64.7959 106.982C64.7959 107.811 65.4679 108.482 66.2959 108.482H99.8779C100.706 108.482 101.378 107.811 101.378 106.982C101.378 106.153 100.706 105.482 99.8779 105.482Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0116 112.783H73.5996C72.7716 112.783 72.0996 113.454 72.0996 114.283C72.0996 115.112 72.7716 115.783 73.5996 115.783H93.0116C93.8396 115.783 94.5116 115.112 94.5116 114.283C94.5116 113.454 93.8396 112.783 93.0116 112.783Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7617 78.2261H81.0117V85.4801C81.0117 86.3091 81.6837 86.9801 82.5117 86.9801C83.3397 86.9801 84.0117 86.3091 84.0117 85.4801V78.2261H91.2517C92.0797 78.2261 92.7517 77.5551 92.7517 76.7261C92.7517 75.8971 92.0797 75.2261 91.2517 75.2261H84.0117V67.9761C84.0117 67.1471 83.3397 66.4761 82.5117 66.4761C81.6837 66.4761 81.0117 67.1471 81.0117 67.9761V75.2261H73.7617C72.9337 75.2261 72.2617 75.8971 72.2617 76.7261C72.2617 77.5551 72.9337 78.2261 73.7617 78.2261Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.262 48H65.251C64.423 48 63.751 48.671 63.751 49.5V56.686H56.5C55.672 56.686 55 57.357 55 58.186V124.069C55 124.898 55.672 125.569 56.5 125.569H108.519C109.347 125.569 110.019 124.898 110.019 124.069V116.883H117.262C118.09 116.883 118.762 116.212 118.762 115.383V49.499C118.762 48.672 118.09 48 117.262 48ZM58 122.57V59.687H107.019V115.317C107.018 115.34 107.012 115.362 107.012 115.385C107.012 115.408 107.018 115.43 107.019 115.453V122.571H58V122.57ZM115.762 113.884H110.019V58.186C110.019 57.357 109.347 56.686 108.519 56.686H66.751V51H115.762V113.884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder4);
export default __webpack_public_path__ + "static/media/order4.7f333132e64b7c802f4b1628611ef0e7.svg";
export { ForwardRef as ReactComponent };